<template>
  <div>
    <el-row class="headMenuBox" type="flex" justify="space-between">
      <el-col :span="7">
        <img src="./../../../assets/img/logo1.png" alt="" />
      </el-col>
      <el-col :span="10"> </el-col>
    </el-row>
    <div class="resultsContainer">
      <div class="formBox">
        <div class="title">考级证书查询</div>
        <div class="form">
          <el-row type="flex" class="formItem">
            <el-col :span="6">
              <p><span style="color: red">*</span>姓名:</p>
            </el-col>
            <el-col>
              <el-input v-model="visibleObj.xm" placeholder="请输入姓名" maxlength="100"></el-input>
            </el-col>
          </el-row>
          <el-row type="flex" class="formItem">
            <el-col :span="6">
              <p>证件号码:</p>
            </el-col>
            <el-col>
              <el-input
                v-model="visibleObj.idNumber"
                placeholder="请输入证件号码"
                maxlength="100"
              ></el-input>
            </el-col>
          </el-row>
          <el-row type="flex" class="formItem">
            <el-col :span="6">
              <p>证书编号:</p>
            </el-col>
            <el-col>
              <el-input
                v-model="visibleObj.passCertNum"
                placeholder="请输入证书编号"
                maxlength="100"
              ></el-input>
            </el-col>
          </el-row>
          <el-row type="flex" class="formItem">
            <p class="tip">温馨提醒：姓名必须填写，证件号码和证书编号至少需要填写一项</p>
          </el-row>
          <el-row type="flex" class="formItem">
            <el-button class="btn" type="primary" @click="getCert">查询</el-button>
          </el-row>
        </div>
      </div>

      <div v-for="(item, index) in result" :key="item.id">
        <div class="result" v-if="item.name">
          <div class="top">
            <div>
              <p>姓名：</p>
              <p class="content">{{ item.name }}</p>
            </div>
            <div>
              <p>证件号码：</p>
              <p class="content">{{ item.idNumber }}</p>
            </div>
            <div>
              <p>考级专业：</p>
              <p class="content">{{ item.subjectName }}</p>
            </div>
          </div>
          <div class="bot">
            <div>
              <p>等级：</p>
              <p class="content">{{ item.testLevel }}</p>
            </div>
            <div>
              <p>证书编号：</p>
              <p class="content">{{ item.passCertNum }}</p>
              <div @click="getCertInfo(item.id)">查看证书</div>
            </div>
            <div>
              <p>成绩：</p>
              <p class="content">{{ item.cjxx }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visibleObj: {
        xm: '',
        idNumber: '',
        passCertNum: '',
      },
      result: [
        {
          name: '', //姓名
          cjxx: '', //成绩
          idNumber: '', //证件号码
          passCertNum: '', //证书编号
          subjectName: '', //考级专业
          testLevel: '', //等级
        },
      ],
      dialogVisible: false, // 控制模态框的显示与隐藏
      certImageUrl: '', // 存储证书的 URL
      visible: false,
      src: 'https://online-registration-system-1256127498.cos.ap-shanghai.myqcloud.com/e8cd4ccbd6f74cdd8a2896fce05e07a6.jpg',
    };
  },
  mounted() {
    // this.getBreadcrumb();
  },
  methods: {
    getCert() {
      if (!this.visibleObj.xm) {
        this.$message.error('请输入姓名');
        return;
      }
      if (!this.visibleObj.idNumber && !this.visibleObj.passCertNum) {
        this.$message.error('证件号码和证书编号至少需要填写一项!');
        return;
      }
      this.$axios.post('/cert/select', this.visibleObj).then((res) => {
        console.log('res', res);
        if (res.data.code == 10000) {
          let data = res.data.data;
          if (data && data.length && data[0].name) {
            this.result = data;
          } else {
            this.$message.error('未查询到相关证书信息');
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getCertInfo(id) {
      window.open(`/api/cert/${id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.headMenuBox {
  background-color: #409eff;
  height: 60px;
  overflow: hidden;

  img {
    height: 60px;
  }

  .iconfont {
    margin-right: 5px;
  }
}

.formBox {
  width: 420px;
  margin: 60px auto 30px auto;

  .title {
    width: 100%;
    color: #409eff;
    font-size: 32px;
    text-align: center;
    font-weight: bold;
  }

  .formItem {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .tip {
      color: red;
    }

    .btn {
      width: 100%;
      height: 40px;
      font-size: 16px;
      border-radius: 4px;
    }
  }
}

.result {
  width: 600px;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px;
  margin-top: 20px;

  .top {
    display: flex;
    justify-content: space-between;

    // margin-bottom: 20px;
    div {
      display: flex;
      align-items: center;
    }
  }

  .bot {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;

    // margin-bottom: 20px;
    div {
      display: flex;
      align-items: center;

      div {
        margin-left: 20px;
        color: #409eff;
        cursor: pointer;
      }
    }
  }
  .content {
    font-weight: 600;
    color: #000;
  }
}
.resultsContainer {
  max-height: calc(100vh - 100px); /* 设置最大高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
  margin-top: 20px; /* 可以根据需要调整 */
}
</style>
